import { createSelector } from 'reselect';
import { once, isEqual } from 'underscore';
import { getSettingsValuesWithDefaults as getSettingsValuesWithDefaultsUtil } from '../utils/themes';
import { getThemeFields, getThemeMessages } from './themeSelectors';
import { getBrandSettings } from 'ContentData/selectors/branding';
const getThemeSettings = state => state.themeSettings;
export const getThemeSettingsRequestStatus = createSelector([getThemeSettings], themeSettings => themeSettings.requestStatus);
export const getUniversalThemeSettingsRequestStatus = createSelector([getThemeSettings], themeSettings => themeSettings.contentRequestStatus);
export const getThemeSettingsMeta = createSelector([getThemeSettings], themeSettings => themeSettings.meta);
export const getThemeSettingsLastSave = createSelector([getThemeSettingsMeta], themeSettingsMeta => themeSettingsMeta.updated);
export const getThemeSettingsId = createSelector([getThemeSettingsMeta], themeSettingsMeta => themeSettingsMeta.id);
export const getThemeSettingsValues = createSelector([getThemeSettings], themeSettings => themeSettings.values.present.values || {});
const getPastThemeSettingsValues = createSelector([getThemeSettings], themeSettings => themeSettings.values.past);
const getFutureThemeSettingsValues = createSelector([getThemeSettings], themeSettings => themeSettings.values.future);
export const getThemeBreakpointStyles = createSelector([getThemeSettings], themeSettings => themeSettings.values.present.breakpointStyles || {});
export const getCanUndo = createSelector([getPastThemeSettingsValues], past => !!past.length);
export const getCanRedo = createSelector([getFutureThemeSettingsValues], future => !!future.length);
const _getBrandSettings = state => {
  return getBrandSettings(state);
};
export const getThemeInheritanceDataOverrides = createSelector([getThemeFields, getThemeSettingsValues, _getBrandSettings], (themeFields, themeSettings, brandSettings) => {
  return {
    themeSettings,
    themeFields,
    brandSettings
  };
});
const makeGetSettingsFormSpec = once(() => {
  const initialSpec = {
    fields: [],
    messages: {}
  };
  let cachedSpec = initialSpec;
  return createSelector([getThemeFields, getThemeMessages], (fields, messages) => {
    const newSpec = Object.assign({}, initialSpec, {
      fields,
      messages
    });
    if (!isEqual(newSpec, cachedSpec)) {
      cachedSpec = newSpec;
      return newSpec;
    }
    return cachedSpec;
  });
});
export const getSettingsFormSpec = makeGetSettingsFormSpec();
const makeGetSettingsValuesWithDefaults = once(() => {
  const initialValues = {};
  let cachedValues = initialValues;
  return createSelector([getThemeFields, getThemeSettings], (fields, settingsValues) => {
    const newValues = getSettingsValuesWithDefaultsUtil(fields, settingsValues);
    if (!isEqual(newValues, cachedValues)) {
      cachedValues = newValues;
    }
    return cachedValues;
  });
});
export const getSettingsValuesWithDefaults = makeGetSettingsValuesWithDefaults();